import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { AppInitializerService } from './framework/utils/app-initializer.service';

const initializeApp = async () => {
  const initializer = new AppInitializerService();
  await initializer.initializeApp();
  return bootstrapApplication(AppComponent, appConfig);
};

initializeApp().catch(err => console.error('Error during initialization:', err));
